import { render, staticRenderFns } from "./adv_users_sungle.vue?vue&type=template&id=49c227dc&viewBox=0%200%2046%2046"
var script = {}


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports